import { render, staticRenderFns } from "./good-shop.vue?vue&type=template&id=3e2e3902&scoped=true"
import script from "./good-shop.vue?vue&type=script&lang=js"
export * from "./good-shop.vue?vue&type=script&lang=js"
import style0 from "./good-shop.vue?vue&type=style&index=0&id=3e2e3902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e3902",
  null
  
)

export default component.exports